 import { defineRule } from 'vee-validate';


defineRule('required', value => {
    if (!value || !value.length) {
        return 'Поле обязательно для заполнения.';
    }
    return true;
});
